import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="The Software Engineer's Guidebook"
        desc="Navigating senior, tech lead, and staff engineer positions at tech companies and startups"
        image="/images/books/the-software-engineers-guidebook.jpg"
        pageType="book"
        author="Gergely Orosz"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/the-software-engineers-guidebook.jpg"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                The Software Engineer's Guidebook
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Gergely Orosz</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Gergely Orosz, the author behind The Pragmatic Engineer newsletter, draws on his
                experience at Uber, Skype, and Microsoft to map out what it takes to grow as a
                software engineer. The book covers the full career arc — from writing clean code
                and getting through code reviews to navigating promotions, tech lead responsibilities,
                and staff-level expectations.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                What makes this book stand out is its honesty about how the industry actually works.
                It addresses the unwritten rules of career growth at tech companies and startups alike,
                covering topics that most engineering books avoid: how decisions really get made, what
                hiring managers look for, and how to build influence without a management title. A
                practical companion for engineers at any stage of their career.
              </p>

            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
